import { Flex } from '@chakra-ui/react';
import AppRoutes from 'config/AppRoutes';
import { useTranslation } from 'react-i18next';
import PageLayout from 'ui/layout/PageLayout';
import RoundedCard from 'ui/molecules/RoundedCard';
import useStepNavigation from 'utils/hooks/useStepNavigation';
import ExtraServicesList from './components/ExtraServicesList';

const PageExtraServices = () => {
  const currentRoute = AppRoutes.EXTRA_SERVICES;
  const { navigateToNextStep, navigateToPreviousStep } =
    useStepNavigation(currentRoute);
  const { t } = useTranslation();

  return (
    <PageLayout
      buttonLabel={t('common.continue')}
      buttonCallback={navigateToNextStep}
      backButton
      backCallback={navigateToPreviousStep}
      layoutStyle={{ justifyContent: 'center' }}
    >
      <RoundedCard
        mt={{ base: 1, md: 8 }}
        pt={{ base: 6, md: 10 }}
        pb={{ base: 12, md: 10 }}
        minH="60%"
      >
        <Flex
          fontFamily="Primary Bold"
          fontWeight={600}
          fontSize={{ sm: 'xl', md: '2xl' }}
          textAlign="center"
          px={{ base: 2, md: 10 }}
          pb={{ base: 10, md: 6 }}
        >
          {t('EXTRA_SERVICES_title')}
        </Flex>
        <ExtraServicesList />
      </RoundedCard>
    </PageLayout>
  );
};

export default PageExtraServices;
